'use strict';


const AnchorsHash = {
    el: null,
    swiper: null,
    sections: [],
    links: [],
    init: function () {
        if (window.location.hash) {
            const targetId = window.location.hash.substring(1);
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
              setTimeout(() => {
                // console.log(targetElement)
                // const y = targetElement.getBoundingClientRect().top - 80;
                // // targetElement.scrollIntoView({behavior: "smooth", block: "top"});
                // window.scrollTo({top: y, behavior: 'smooth'});

                const headerHeight = document.querySelector('.c-header') ? document.querySelector('.c-header').offsetHeight : 82;
                const anchorsHeight = document.querySelector('.c-anchors') ? document.querySelector('.c-anchors').offsetHeight : 80;
                const offset = headerHeight + anchorsHeight;
                console.log(headerHeight, anchorsHeight, offset)
                const top = targetElement.getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({ top, behavior: "smooth" });
              }, 100);
            }
          }
    }
}

export default AnchorsHash;